import * as React from 'react';
import { MainMenuGroupItem } from './MainMenu';
import { Link } from 'components/link/Link';
import { style } from 'typestyle';
import { SubMenuItemComponent } from './SubMenuItemComponent';

export class GroupMenuItemComponent extends React.Component<GroupMenuItemComponentProps> {

    public render() {
        const url: string = this.props.item.children[0].url;
        const selected: boolean = this.isSelected();
        return (
            <div style={{ width: '100%' }}>
                <Link
                    href={url}
                    forceReload={url.lastIndexOf(".rsc") != url.length - 4}
                    className={styles.link}
                >
                    <div className={"material-icons " + styles.icon}>
                        {this.props.item.icon}
                    </div>
                    <div className={styles.title}>
                        {this.props.item.title}
                    </div>
                </Link>



                {selected &&
                    this.props.item.children.map((item) => {
                        return <SubMenuItemComponent key={"" + item.url} currentUrl={this.props.currentUrl} item={item} />;
                    })
                }
            </div>
        );
    }

    private isSelected(): boolean {
        for (var item of this.props.item.children) {
            if (item.url == this.props.currentUrl) {
                return true;
            }
        }

        return false;
    }

}

export class GroupMenuItemComponentProps {
    public item: MainMenuGroupItem;
    public currentUrl: string;
}

const styles = {
    link: style({
        padding: '10px 20px 10px 20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        $nest: {
            '&:visited': {

            },
            '&:hover': {
                opacity: 0.7
            }
        }
    }),
    icon: style({
        display: 'inline-block',
        paddingRight: '20px',
        color: 'rgba(255, 255, 255, 0.4)'
    }),
    title: style({
        display: 'inline-block',
        fontSize: '15px',
        fontWeight: 400,
        color: 'rgba(255, 255, 255, 0.75)'
    }),
}